import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  smartphone = false;
  tablet = false;
  notebook = false;
  computer = false;

  getWidthDevice(): number {
    return window.innerWidth;
  }

  returnSmartphone(): boolean {
    const width = this.getWidthDevice();
    return this.returnDevice(width < 576 || this.smartphone);
  }

  returnTablet(): boolean {
    const width = this.getWidthDevice();
    return this.returnDevice((width >= 576 && width < 700) || this.tablet);
  }

  returnNotebookAndPc(): boolean {
    const width = this.getWidthDevice();
    return this.returnDevice((width >= 700 && width < 992) || this.notebook);
  }

  returnPc(): boolean {
    const width = this.getWidthDevice();
    return this.returnDevice(width >= 992 || this.computer);
  }

  returnDevice(returnDevice: boolean): boolean {
    this.clearDevice();
    return returnDevice;
  }

  clearDevice(): void {
    this.computer = false;
    this.notebook = false;
    this.smartphone = false;
    this.tablet = false;
  }

  setDevice(device): void {
    switch (device) {
      case 1: {
        this.smartphone = true;
        break;
      }
      case 2: {
        this.tablet = true;
        break;
      }
      case 3: {
        this.notebook = true;
        break;
      }
      case 4: {
        this.computer = true;
        break;
      }
    }
  }
}
